import React from 'react'
import LogoClicksign from '@resources/imgs/logo-empresa.png'
import { formatOrderDate } from '../../utils/formatOrderDate'
import './ContractStatus.css'

interface CanceledContractStatusProps {
  canceled_at?: Date | null
}

const CanceledContractStatus: React.FC<CanceledContractStatusProps> = ({ canceled_at }) => {
  return (
    <div className="contract-status-container">
      <div className="d-flex align-items-start gap-4">
        <div className="clicksign-logo-box bg-secondary-subtle">
          <img src={LogoClicksign} alt="Clicksign" />
        </div>

        <div className="flex-grow-1">
          <div className="status-header mb-3">
            <span className="status-icon text-secondary me-2" style={{ fontSize: '1.5rem' }}>✗</span>
            <h5 className="d-inline mb-0 text-secondary">Contrato cancelado</h5>
          </div>
          <p className="text-muted mb-4">
            Cancelado em <strong>{formatOrderDate(canceled_at ?? undefined)}</strong>
          </p>

          <div className="alert alert-secondary d-flex gap-3 mb-0" style={{ backgroundColor: '#F8F9FA', border: '1px solid #DEE2E6' }}>
            <div style={{ fontSize: '1.5rem' }}>🚫</div>
            <div className="flex-grow-1">
              <p className="mb-0" style={{ color: '#6C757D' }}>
                O contrato foi cancelado. Entre em contato com nossa Central de Atendimento para mais informações.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CanceledContractStatus
